import { Button, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';

type ConfirmRemovePrimaryModalProps = {
  isOpen: boolean;
  isPending: boolean;
  onOpenChange: () => void;
  name: string;
  onSubmit: () => void;
};

export const ConfirmRemovePrimaryModal = ({
  isOpen,
  isPending,
  onOpenChange,
  name,
  onSubmit,
}: ConfirmRemovePrimaryModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      size="xl"
      onOpenChange={onOpenChange}
      scrollBehavior="inside"
      hideCloseButton
      classNames={{
        header: 'text-hl! text-base-10 font-secondary flex flex-col gap-1 bg-base-80 rounded-2xl',
        body: 'bg-base-80 py-4',
        footer: 'bg-base-80 py-3 rounded-2xl',
      }}
    >
      <ModalContent>
        <ModalHeader>
          {`Remove 'Primary'?`}
          <Divider />
        </ModalHeader>
        <ModalBody>
          <div className="flex gap-6 flex-col">
            <div className="text-m-r">
              {`Are you sure you want to remove the 'Primary' label from `}
              <span className="text-m-m">{name}?</span>
            </div>
            <div className="flex text-m-r">
              Having a designated primary contact helps ensure clearer communication within roles that have multiple
              representatives.
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="flex flex-col">
          <Divider />
          <div className="flex gap-3 py-3">
            <Button disabled={isPending} className="h-9 flex-1" variant="outline" onPress={onOpenChange}>
              Discard
            </Button>
            <Button className="h-9 flex-1" isLoading={isPending} variant="solid" onPress={onSubmit}>
              {`Remove 'Primary'`}
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
